"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var noop_ = function () { };
var hook_ = noop_;
function detect(id) {
    hook_(id);
}
exports.detect = detect;
function hook(hook) {
    hook_ = hook || noop_;
}
exports.hook = hook;
